import { useEffect } from "react";
import { authRepository } from "../api/auth-repository";
import { useAuthStore } from "@/core/auth/auth-store";
import { useCurrentClubStore } from "@/core/auth/current-club-store";

export function useAuthListener(): void {
  const setUser = useAuthStore((s) => s.setUser);
  const clearCurrentClub = useCurrentClubStore((s) => s.clear);

  useEffect(() => {
    const unsubscribe = authRepository.observe((user) => {
      setUser(user);
      // When auth tears down (sign-out / token expiry), drop any persisted
      // club selection so the next session re-runs the picker.
      if (!user) clearCurrentClub();
    });
    return unsubscribe;
  }, [setUser, clearCurrentClub]);
}
